import {
  add, eachMinuteOfInterval, format, intlFormat, set,
} from 'date-fns';

export default ({ interval = 5 } = {}) => {
  const startTime = set(new Date(), { hours: 0, minutes: 0 });
  const endTime = add(startTime, { hours: 23, minutes: 59 });
  const times = eachMinuteOfInterval({ start: startTime, end: endTime }, { step: interval });

  return times.map((time, i) => ({
    id: i,
    label: intlFormat(time, { hour: 'numeric', minute: 'numeric' }, { locale: document.documentElement.lang || 'en' }),
    value: format(time, 'h:mmaaa'),
  }));
};
